import { getCloudId } from '../constants';
export var getConfluencePageAri = function getConfluencePageAri(pageId) {
  return "ari:cloud:confluence:".concat(getCloudId(), ":page/").concat(pageId);
};
export var getPageIdFromAri = function getPageIdFromAri(ari) {
  // eslint-disable-next-line require-unicode-regexp
  var match = ari.match(/ari:cloud:confluence:[^:]+:page\/(\d+)/);
  if (match) {
    return match[1];
  }
  throw new Error("Invalid page ARI: ".concat(ari));
};
export var getContentPropertyAri = function getContentPropertyAri(contentPropertyId) {
  return "ari:cloud:confluence:".concat(getCloudId(), ":content/").concat(contentPropertyId);
};
export var getContentPropertyIdFromAri = function getContentPropertyIdFromAri(ari) {
  // eslint-disable-next-line require-unicode-regexp
  var match = ari.match(/ari:cloud:confluence:[^:]+:content\/([^/]+)/);
  if (match) {
    return match[1];
  }
  throw new Error("Invalid content property ARI: ".concat(ari));
};